import { useContext, useMemo } from 'react'
import { buildPanelCheckItems } from 'components/Cruises/SearchPage/Filters/Inputs/buildPanelCheckItems'
import FilterPanelCheckboxGroup from 'components/Common/FilterPanel/FilterPanelCheckboxGroup'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'

import { trackEvent } from 'analytics/analytics'
import { mapCruiseLineFilterToSnowplowSearchEvent } from 'analytics/mapSnowplowSearchTracking'
import { searchEventWithContext } from 'analytics/snowplow/events'
import useCruiseTravellerTypeLabel from 'hooks/Cruise/useCruiseTravellerTypeLabel'

interface Props {
  travellerTypes?: Set<string>
  travellerTypeFacets: Array<App.CruiseSearchFacetV2Item>
  onChange: (value: any) => void
}

function CruiseTravellerTypeFilter({
  travellerTypes,
  travellerTypeFacets,
  onChange,
}: Props) {
  const globalSearchState = useContext(GlobalSearchStateContext)
  const formatTravellerTypeLabel = useCruiseTravellerTypeLabel()

  const travellerTypeItems = useMemo(() => {
    return buildPanelCheckItems(travellerTypeFacets.map(facet => ({
      ...facet,
      label: formatTravellerTypeLabel(facet.slug) ?? facet.label,
    })))
  }, [formatTravellerTypeLabel, travellerTypeFacets])

  return <div data-testid="cruise-traveller-type-filter">
    <FilterPanelCheckboxGroup
      name="travellerTypes"
      items={travellerTypeItems}
      onChange={(e) => {
        trackEvent(searchEventWithContext({
          searchEvent: { type: 'filters' },
          sortContext: { value: 'recommended' },
          searchContext: mapCruiseLineFilterToSnowplowSearchEvent(globalSearchState),
          filterContexts: [{
            label: e.target.value,
            type: 'traveller_type',
            value: e.target.checked ? 'selected' : 'unselected',
          }],
        }))

        onChange(e)
      }}
      defaultSelected={travellerTypes}
    />
  </div>
}

export default CruiseTravellerTypeFilter
